// Shared with mushroom-bank-ui/src/pages/Plates.js (badge colors) and
// the home hub's plate chips (components/hub), so both read the same source
// instead of drifting apart.
export const PLATE_STATUS_COLORS = {
  awaiting_creation:     { background: 'var(--c-purple-soft)', color: 'var(--c-purple-fg)' },
  pending:               { background: 'var(--c-info-soft)', color: 'var(--c-info-fg)' },
  ready_to_transfer:     { background: 'var(--c-success-soft)', color: 'var(--c-success-fg)' },
  slow_growth:           { background: 'var(--c-warning-soft)', color: 'var(--c-warning-text-fg)' },
  contaminated:          { background: 'var(--c-danger-soft)', color: 'var(--c-danger-2-fg)' },
  in_rescue:             { background: 'var(--c-warning-soft-4)', color: 'var(--c-warning-text-2-fg)' },
  failed:                { background: 'var(--c-bg-muted)', color: 'var(--c-text-muted-fg)' },
  transferred_to_slants: { background: 'var(--c-purple-soft-3)', color: 'var(--c-purple-2-fg)' },
  transferred_to_plate:  { background: 'var(--c-info-soft-6)', color: 'var(--c-info-7-fg)' },
};

// Shared with mushroom-bank-ui/src/pages/Slants.js (badge colors) and the
// home hub's bank table.
export const SLANT_STATUS_COLORS = {
  healthy:      { background: 'var(--c-success-soft)', color: 'var(--c-success-fg)' },
  contaminated: { background: 'var(--c-danger-soft)', color: 'var(--c-danger-2-fg)' },
  discarded:    { background: 'var(--c-bg-muted)', color: 'var(--c-text-muted-fg)' },
  in_refresh:   { background: 'var(--c-warning-soft-4)', color: 'var(--c-warning-text-2-fg)' },
};
